export default "__VITE_ASSET__BV6cs1qe__"